import { useSelection } from "./selection";

// Mobile-friendly on-screen modifier keys + selection counter.
//
// Tap ⇧ to latch shift, then tap a task row → range from the anchor to
// the tapped row.  Tap ⌃ to latch ctrl/cmd, then tap rows to add/remove
// individually.  Latch state is mutually exclusive (toggling one clears
// the other).  Tapping a row "consumes" the latch — the modifier
// auto-releases so chord-once-per-tap matches the desktop habit.
//
// Visible at all times so the user can engage selection mode without
// hunting through menus.  Hover-only keyboards on desktop also benefit:
// pinning ⇧ removes the need to keep a key held.

export function ModifierBar() {
  const {
    selectedIds,
    stickyShift,
    stickyCtrl,
    toggleStickyShift,
    toggleStickyCtrl,
    clearSelection,
  } = useSelection();

  const count = selectedIds.size;
  const multi = count > 1;

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={toggleStickyShift}
        title="Shift: tap to select a range"
        aria-pressed={stickyShift}
        className={`rounded-md border px-2 py-1 text-xs font-medium ${
          stickyShift
            ? "border-blue-500 bg-blue-500 text-white"
            : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        }`}
      >
        ⇧ Shift
      </button>
      <button
        type="button"
        onClick={toggleStickyCtrl}
        title="Ctrl: tap rows to toggle individually"
        aria-pressed={stickyCtrl}
        className={`rounded-md border px-2 py-1 text-xs font-medium ${
          stickyCtrl
            ? "border-blue-500 bg-blue-500 text-white"
            : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        }`}
      >
        ⌃ Ctrl
      </button>
      {multi && (
        <button
          type="button"
          onClick={clearSelection}
          title="Clear selection"
          className="ml-1 rounded-md border border-slate-300 bg-slate-100 px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-200 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
        >
          {count} selected · clear
        </button>
      )}
    </div>
  );
}
